import { Component, AfterContentInit, ElementRef } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../conf/app.constants';
import { CriteriaFormulaDTO } from '../../api/plyca-dtos-v2';

import {
  FormConfig,
  FormAction,
  FormDialogResponse,
  CancelFormAction
} from '../../components/forms/form.objects';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';

import * as lodash from 'lodash';
import { ServiceLocator } from '../../ServiceLocator';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { UIService } from '../../ui.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { TenderingBaseAction } from '../eTenderingDefinition/tenderingBase.component';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { ConfirmationService } from 'primeng-lts/api';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { FormService } from '../../components/forms/form.service';

@Component({
  selector: 'awardcritformula',
  templateUrl: 'awardCriteriaFormulas.template.html',
  providers: [DialogService]
})
export class awardCriteriaFormulasComponent extends BaseComponent implements AfterContentInit {
  context: any;
  private loaded = false;


  elements: any;

  translationService: TranslateService;

  CANCEL_ACTION = new CancelFormAction();

  constructor(public dialogService: DialogService,
    private ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    public plycaService: PlycaDataService,
    private el: ElementRef,
    private configuration: Configuration,
    private confirmationService: ConfirmationService,
    private uiService: UIService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    public helpService: HelpService,
    private plycaErrorHandler: PlycaErrorHandler,
    private waitService: WaitLoadingService,
    private formService: FormService
  ) {
    super();
    this.translationService = ServiceLocator.injector.get(TranslateService);
    this.context = dialogConfig['context'];
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.ADMIN_FORMULAS));
  }

  ngAfterContentInit(): void {

    this.headerActionsService.setTaskDescription(this.elem, 'AwardCriteria.adm', 'fas fa-calculator', this.isLoaded.bind(this));
    this.subscribe(this.headerActionsService.addAction(
      'AwardCriteriaFormula.add',
      'fas fa-plus',
      'btn-primary',
      true
    ), () => {
      this.add();
    });
    this.headerActionsService.addDivider();

    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ), () => {
      this.uiService.routeBack();
    });
    this.load();
    setTimeout(() => {
      this.el.nativeElement.focus();
    }, 500);
  }

  load() {
    this.subscribe(this.plycaService
      .query<CriteriaFormulaDTO>(this.configuration.FORMULAS_SERVICE_URL), (value: any) => {
        if (value.content) {
          this.elements = value.content;
        } else {
          this.elements = [];
        }

        this.loaded = true;
      });
  }

  isLoaded(): boolean {
    return this.loaded;
  }



  isLoadedResult() {
    return this.isLoaded() && (this.elements && this.elements.length > 0);
  }

  cancel(): void {
    this.ref.close();
  }

  delete(row: any) {
    this.confirmationService.confirm({


      message: this.translationService.instant('General.confirm.action.delete'),
      accept: () => {
        this.subscribe(this.plycaService.delete(this.getServiceURL(), row.identifier), (result: any) => {
          this.load();


        });

      }
    });
  }

  edit(rowData?: any, editable?: boolean) {

    const config = this.getDialogConfig();
    // config.height = '90%';
    let data = lodash.cloneDeep(rowData);

    let actions = new Array<FormAction<any>>();
    if (editable || !rowData) {
      actions.push(this.getActionForm());
      actions.push(new CancelFormAction());

    }
    if (editable === undefined) {
      editable = true;
    }
    // actions.push(new CancelFormAction());
    config['formConfig'] = new FormConfig(undefined,
      this.getFormSettingURL(),
      this.dtoToBean(data),
      actions,
      false,
      false, [HelpType.ADMIN_FORMULAS], !editable
    );
    config['readonly'] = !editable;

    const dialogRef = this.dialogService.open(formPlycaComponent, config);
    this.subscribe(dialogRef.onClose, (response: FormDialogResponse<any>) => {
      if (response && response.actionId !== this.CANCEL_ACTION.actionId) {
        this.emitUpdate(rowData, response.model);
      }
    },
      (error: any) => {
        const ref = this.plycaErrorHandler.showServerError(error);
        this.subscribe(ref.onClose);


        console.log(error);
      }
    );
  }
  emitUpdate(rowData?: any, updatedData?: any): void {
    this.load();
  }

  getFormSettingURL(): string {
    return 'CriteriaFormulaSettings.json';
  }
  dtoToBean(data: any): any {
    return data;
  }
  beanToDTO(data: any): any {
    return data;
  }
  /*
  getActionForm(): FormAction<any> {
    return new FormAction<any>(this.plycaService, this.getServiceURL(), this.getValidationCtx(),
      this.beanToDTO, 'General.save', 'btn btn-primary', 'fa fa-save', 'aceptar');
  }*/


  getServiceURL(): string {
    return (this.configuration.FORMULAS_SERVICE_URL

    );
  }
  getValidationCtx(): string {
    return '';
  }

  getDialogConfig(titleKey?: string): DynamicDialogConfig {
    return {
      header: this.translationService.instant('AwardCriteriaFormula.title'),
      width: '90%',
      styleClass: 'formEdition',
      closable: true,
      closeOnEscape: true,
      baseZIndex: 1510
    } as DynamicDialogConfig;
  }

  add() {
    this.edit();
  }

  getActionForm(): FormAction<any> {
    return new TenderingBaseAction<any>(this.plycaService,
      this.confirmationService,
      this.translationService,
      this.waitService,
      this.formService,
      this.getServiceURL(),
      this.getValidationCtx(),
      this.beanToDTO,
      undefined,
      'General.save', 'btn btn-primary', 'fa fa-save', 'aceptar');

  }
}











export class FormulasBaseAction implements FormAction<any> {
  buttonTextKey: string;
  buttonClass: string;
  imageClass: string;
  closeOnSuccess = true;
  actionId: string;
  visibility = true;

  constructor(
    private plycaService: PlycaDataService,
    private url: string,
    private validationCtx: string,
    private transformationFunc: Function,
    buttonTextKey: string,
    buttonClass: string,
    imageClass: string,
    actionId: string
  ) {
    this.buttonTextKey = buttonTextKey;
    this.buttonClass = buttonClass;
    this.imageClass = imageClass;
    this.actionId = actionId;
  }

  public executeFormAction(model: any): Observable<any> {
    return this.insertOrUpdate(model);
  }

  private insertOrUpdate(model: any): Observable<any> {
    if (model.identifier) {
      return this.plycaService.update<any>(
        this.url,
        this.transformationFunc(model)
      );
    } else {
      return this.plycaService.insert<any>(
        this.url,
        this.transformationFunc(model)
      );
    }
  }
  private getValidationCtxName(model: any): string {
    return (model.identifier ? 'Update' : 'Insert') + this.validationCtx;
  }


}
